import $ from 'jquery';

function checkedValues($checkboxes) {
    return $checkboxes.filter(':checked').map(function () { return $(this).val(); }).get();
}

function init() {
    const $accordion = $('#ehsCatalogAccordion');
    if ($accordion.length === 0) return;

    const $items = $accordion.find('.accordion-item');
    const $search = $('#ehsCatalogSearch');
    const $resultCount = $('#ehsCatalogResultCount');
    const $noResults = $('#ehsCatalogNoResults');

    function applyFilters() {
        const selectedRoles = checkedValues($('.ehs-filter-role'));
        const selectedTopics = checkedValues($('.ehs-filter-topic'));
        const selectedFormats = checkedValues($('.ehs-filter-format'));
        const searchText = ($search.val() || '').toLowerCase().trim();

        let visibleCount = 0;

        $items.each(function () {
            const $item = $(this);
            const itemRoles = ($item.data('roles') || '').toString().split(',').filter(Boolean);
            const itemTopics = ($item.data('topics') || '').toString().split(',').filter(Boolean);
            const itemFormats = ($item.data('formats') || '').toString().split(',').filter(Boolean);
            const itemSearch = ($item.data('search') || '').toString();

            const matchesRoles = selectedRoles.length === 0 || selectedRoles.some(r => itemRoles.includes(r));
            const matchesTopics = selectedTopics.length === 0 || selectedTopics.some(t => itemTopics.includes(t));
            const matchesFormats = selectedFormats.length === 0 || selectedFormats.some(f => itemFormats.includes(f));
            const matchesSearch = searchText === '' || itemSearch.includes(searchText);

            const visible = matchesRoles && matchesTopics && matchesFormats && matchesSearch;
            $item.toggleClass('d-none', !visible);
            if (visible) visibleCount++;
        });

        $resultCount.text(`${visibleCount} result${visibleCount === 1 ? '' : 's'}`);
        $noResults.toggleClass('d-none', visibleCount !== 0);
    }

    $('.ehs-filter-role, .ehs-filter-topic, .ehs-filter-format').on('change', applyFilters);
    $search.on('input', applyFilters);

    $('#ehsCatalogExpandAll').on('click', function () {
        $items.filter(':not(.d-none)').each(function () {
            $(this).find('.accordion-collapse').addClass('show');
            $(this).find('.accordion-button').removeClass('collapsed').attr('aria-expanded', 'true');
        });
    });

    $('#ehsCatalogCollapseAll').on('click', function () {
        $items.find('.accordion-collapse').removeClass('show');
        $items.find('.accordion-button').addClass('collapsed').attr('aria-expanded', 'false');
    });

    $('#ehsCatalogReset').on('click', function () {
        $('.ehs-filter-role, .ehs-filter-topic, .ehs-filter-format').prop('checked', false);
        $search.val('');
        applyFilters();
    });

    applyFilters();
}

$(document).on('page-init-complete', init);
